module.exports = __webpack_public_path__ + "static/media/hide_icon.c4c03570.svg";